import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  default = {
    project: 'npc',
    type: 'public'
  }

  constructor(
    private http: HttpClient,
  ) { }


  /**
   * 
   * @param url 
   * @param params 
   * @param project 
   * @param type 
   * @returns Observable<any>
   */
  get(url: string, params: any = '', type: string = this.default.type, project: string = this.default.project): Observable<any> {

    console.log('[START: GET] - ' + url, params);

    let p: string = params ? '/' + params : '';

    return this.http.get(environment.apiUrls[project][type] + '/' + url + p);
  }


  /**
   * 
   * @param url 
   * @param params 
   * @param project 
   * @param type 
   * @param options 
   * @returns Observable<any>
   */
  post(url: string, params: any, type: string = this.default.type, project: string = this.default.project, options?: any): Observable<any> {

    console.log('[START: POST] - ' + url, params);
    return this.http.post(environment.apiUrls[project][type] + '/' + url, params, options);
  }


  /**
   * 
   * @param url 
   * @param params 
   * @param project 
   * @param type 
   * @returns Observable<any>
   */
  put(url: string, params: any, type: string = this.default.type, project: string = this.default.project): Observable<any> {

    console.log('[START: PUT] - ' + url, params);
    return this.http.put(environment.apiUrls[project][type] + '/' + url, params);
  }


  /**
   * 
   * @param url 
   * @param params 
   * @param project 
   * @param type 
   * @returns Observable<any>
   */
  delete(url: string, params: any, type: string = this.default.type, project: string = this.default.project): Observable<any> {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: params
    };

    console.log('[START: DELETE] - ' + url, params);
    return this.http.delete(environment.apiUrls[project][type] + '/' + url, options);
  }


  /**
   * 
   * @param url string
   * @param params any
   * @param type string
   * @param project string
   * @returns Observable<any>
   */
  upload(url: string, params: any, type: string = 'private', project: string = 'files'): Observable<any> {

    return this.http.post(environment.apiUrls[project][type] + '/' + url, params, {
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * 
   * @param url 
   * @param params 
   * @param type 
   * @param project 
   * @returns 
   */
  uploadKaspi(url: string, params: any, type: string = 'private', project: string = 'files'): Observable<any> {

    return this.http.post(environment.apiUrls[project][type] + '/' + url, params, {
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * 
   * @param url 
   * @param params 
   * @param type 
   * @param project 
   * @returns 
   */
  getImage(url: string, params: any, type: string = 'private', project: string = 'files'): Observable<any> {
    return this.http.get(environment.apiUrls[project][type] + '/' + url + '/' + params);
  }
  
  /**
   * 
   * @param url 
   * @param params 
   * @param type 
   * @param project 
   * @returns 
   */
   getFileInfo(url: string, params: any, type: string = 'private', project: string = 'files'): Observable<any> {
    return this.http.get(environment.apiUrls[project][type] + '/' + url + '/' + params);
  }

  /**
   * 
   * @param url 
   * @param type 
   * @param project 
   * @returns 
   */
  downloadFile(url: string, type: string = 'private', project: string = 'files'): Observable<HttpResponse<Blob>>{

    console.log('[START: DOWNLOAD] - ' + url);

    return this.http.get(environment.apiUrls[project][type] + '/' + url,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  /**
   * 
   * @param url 
   * @param params 
   * @param type 
   * @param project 
   * @returns 
   */
  downloadMediaFile(url: string, params: any, type: string = 'private', project: string = 'files'): Observable<HttpResponse<Blob>>{

    console.log('[START: DOWNLOAD_MEDIA] - ' + url);

    return this.http.post(environment.apiUrls[project][type] + '/' + url, params, 
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

}
